<template functional>
  <div
    v-if="props.value"
    class="dataset-cell-tag-bank tag"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
  >
    <b-tooltip
      v-if="props.row.Bank.Name"
      :label="props.row.Bank.Name"
    >
      <span class="dot-decor">{{ props.row.Bank.AccountLast4 }}</span>
    </b-tooltip>
    <span
      v-else
      class="dot-decor"
    >{{ props.row.Bank.AccountLast4 }}</span>
  </div>
</template>

<script>
import findInvertColor from '@/lib/find-invert-color'
import ModuleBase from './module-base'

export default {
  name: 'DatasetCellTagStatus',
  mixins: [ModuleBase],
}
</script>

<style lang="scss">
.dataset-cell-tag-bank .dot-decor {
  &::before {
    content: '\25E6\25E6\25E6\25E6\25E6';
    display: inline-block;
    margin-right: 5px;
  }
}
</style>
